import React from 'react';
import { useTranslation } from 'react-i18next';
import PropTypes from 'prop-types';
import { NAME_SPACE } from 'i18n';
import { ToolbarContainer, ViewTable } from 'shared';
import { useViewOrderHistoryBuildTable } from './useViewOrderHistoryBuildTable';

export function ViewOrderHistory({ orderHistory }) {
  const { t } = useTranslation(NAME_SPACE.ORDERS);
  const initialSorting = { property: 'date', direction: 'desc' };

  const { rows, headCells, getHistory } = useViewOrderHistoryBuildTable(orderHistory, t, initialSorting);

  return (
    <>
      <ToolbarContainer title={t('history.name')}>
        <ViewTable
          rows={rows}
          cells={headCells}
          onFetchData={getHistory}
          defaultOrderBy={initialSorting}
          allowRowSelection={false}
        />
      </ToolbarContainer>
    </>
  );
}

ViewOrderHistory.propTypes = {
  orderHistory: PropTypes.array
};
